import * as React from "react";
import { MbnIcon } from "sb-resp-ui";
import { SecondaryHeading } from "../SecondaryHeading";
import { HeadingTitle } from "../HeadingTitle";
export const PreliveOutrightHeading = (props) => React.createElement(React.Fragment, null,
    React.createElement(SecondaryHeading, { componentPrefix: props.componentPrefix },
        React.createElement(HeadingTitle, { name: props.name, eventsCount: "" }),
        props.mbnTag &&
            React.createElement(MbnIcon, { tagNumber: props.mbnTag })),
    props.children);
//# sourceMappingURL=PreliveOutrightHeading.js.map